import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatTreeModule } from "@angular/material/tree";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { TranslocoModule } from "@jsverse/transloco";

import { HierarchySelectorComponent } from "./hierarchy-selector.component";
import { HierarchyModificationDialogComponent } from "./hierarchy-modification-dialog/hierarchy-modification-dialog.component";
import { GroupsFilterPipe } from "./pipes/groups-filter.pipe";
import { HierarchyDeletionDialogComponent } from "./hierarchy-deletion-dialog/hierarchy-deletion-dialog.component";
import { LorenAssetSelectionModule } from "../loren-asset-selection/loren-asset-selection.module";
import { LorenImageModule } from "../../pipes/loren-image/loren-image.module";
import { HierarchySelectionDialogComponent } from "./hierarchy-selection-dialog/hierarchy-selection-dialog.component";
import { LorenCardModule } from "../loren-card/loren-card.module";
import { HierarchyAutocompleteFieldComponent } from "./hierarchy-autocomplete-field/hierarchy-autocomplete-field.component";
import { LorenSharedDirectivesModule } from "../../directives/loren-shared-directives.module";

@NgModule({
  declarations: [
    HierarchySelectorComponent,
    GroupsFilterPipe,
    HierarchyModificationDialogComponent,
    HierarchyDeletionDialogComponent,
    HierarchySelectionDialogComponent,
    HierarchyAutocompleteFieldComponent,
  ],
  imports: [
    CommonModule,
    MatTreeModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    MatInputModule,
    MatProgressSpinner,
    FormsModule,
    TranslocoModule,
    MatRadioModule,
    MatSelectModule,
    MatChipsModule,
    MatAutocompleteModule,
    LorenAssetSelectionModule,
    LorenImageModule,
    MatCardModule,
    LorenCardModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatListModule,
    LorenSharedDirectivesModule,
  ],
  exports: [HierarchySelectorComponent, HierarchyAutocompleteFieldComponent],
})
export class LorenHierarchySelectorModule {}
